import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
	ChooseMealPlanResolverService,
	RECIPE_ADD_INGREDIENTS_MODAL_PATH,
	RECIPE_SHARE_MODAL_PATH,
} from '@woolworthsnz/recipe';
import { MODAL_ROUTES } from '@woolworthsnz/shop';
import { RecipesPage } from './pages/recipes/recipes.page';

const routes: Routes = [
	{
		path: ``,
		component: RecipesPage,
	},
	{
		path: `search`,
		loadComponent: () => import('./pages/recipes-search/recipes-search.page').then((c) => c.RecipesSearchPage),
	},
	{
		path: `:categoryId/:categoryName`,
		loadComponent: () =>
			import('./pages/recipes-category/recipes-category.page').then((c) => c.RecipesCategoryPage),
	},
	{
		path: `:categoryId/:categoryName/:subcategoryId/:subCategoryName`,
		loadComponent: () =>
			import('./pages/recipes-category/recipes-category.page').then((c) => c.RecipesCategoryPage),
	},
	{
		path: `:mealtime/:recipeId/:recipeName`,
		loadComponent: () => import('./pages/recipe-details/recipe-details.page').then((c) => c.RecipeDetailsPage),
		resolve: {
			mealPlanning: ChooseMealPlanResolverService,
		},
		children: [
			{
				path: RECIPE_SHARE_MODAL_PATH,
				outlet: MODAL_ROUTES.RECIPE_MODAL,
				loadComponent: () => import('@woolworthsnz/recipe').then((c) => c.ShareModalComponent),
				data: {
					name: 'recipe-share',
				},
			},
			{
				path: `${RECIPE_ADD_INGREDIENTS_MODAL_PATH}/:id`,
				outlet: MODAL_ROUTES.RECIPE_MODAL,
				loadComponent: () => import('@woolworthsnz/recipe').then((c) => c.AddIngredientsModalComponent),
				data: {
					name: 'recipe-add-ingredients',
				},
			},
			{
				path: MODAL_ROUTES.MEAL_PLANNING_CHOOSE_PLAN_PATH,
				outlet: MODAL_ROUTES.RECIPE_MODAL,
				loadComponent: () => import('@woolworthsnz/recipe').then((c) => c.ChoosePlanModalComponent),
				data: {
					feature: 'MealPlanning',
				},
				resolve: {
					mealPlanning: ChooseMealPlanResolverService,
				},
			},
		],
	},
	{
		path: '**',
		loadComponent: () => import('@woolworthsnz/styleguide').then((c) => c.NotFoundErrorComponent),
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class RecipesRoutingModule {}
